import { render } from "./BlogArticle.vue?vue&type=template&id=96545b24&scoped=true"
import script from "./BlogArticle.vue?vue&type=script&lang=js"
export * from "./BlogArticle.vue?vue&type=script&lang=js"

import "./BlogArticle.vue?vue&type=style&index=0&id=96545b24&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96545b24"]])

export default __exports__